"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.weekStartIndex = exports.weekdayShortName = exports.weekdayName = exports.weekdayShortNames = exports.weekdayNames = exports.monthNames = exports.fullDateRangeShort = exports.fullDateShort = exports.hour = exports.hourMinute = exports.weekDayMonthDayYearShort = exports.weekDayMonthDayYear = exports.weekDayMonthDay = exports.monthDayYearShort = exports.numericDate = exports.monthDayShort = void 0;
var ordinal_1 = require("./ordinal");
var DateTimeFormatPartTypes;
(function (DateTimeFormatPartTypes) {
    DateTimeFormatPartTypes["Day"] = "day";
    DateTimeFormatPartTypes["Hour"] = "hour";
    DateTimeFormatPartTypes["Minute"] = "minute";
    DateTimeFormatPartTypes["Month"] = "month";
    DateTimeFormatPartTypes["Second"] = "second";
    DateTimeFormatPartTypes["TimeZoneName"] = "timeZoneName";
    DateTimeFormatPartTypes["Weekday"] = "weekday";
    DateTimeFormatPartTypes["Era"] = "era";
    DateTimeFormatPartTypes["Year"] = "year";
})(DateTimeFormatPartTypes || (DateTimeFormatPartTypes = {}));
var addOrdinals = function (locale, date, formatter, options) {
    // Skip ordinals if formatToParts is not available
    if (Intl.DateTimeFormat.prototype.formatToParts == null) {
        return formatter.format(date);
    }
    var parts = formatter.formatToParts(date);
    var ordinalParts = ordinal_1.formatOrdinalParts(locale, parts, options);
    return ordinalParts.reduce(function (a, p) { return a + p.value; }, '');
};
var DatePeriod;
(function (DatePeriod) {
    DatePeriod[DatePeriod["AM"] = 0] = "AM";
    DatePeriod[DatePeriod["PM"] = 1] = "PM";
})(DatePeriod || (DatePeriod = {}));
var getDateDayPeriod = function (date) {
    return date.getHours() >= 12 ? DatePeriod.PM : DatePeriod.AM;
};
/**
 * Month and day short date according to locale
 * @example
 * monthDayShort('en', date) === 'Apr 8th'
 */
exports.monthDayShort = function (locale, date) {
    var options = {
        month: 'short',
        day: 'numeric',
    };
    var formatter = new Intl.DateTimeFormat(locale, options);
    return addOrdinals(locale, date, formatter, options);
};
/**
 * Numeric date according to locale
 * @example
 * numericDate('en', date) === '8'
 */
exports.numericDate = function (locale, date) {
    var options = {
        day: 'numeric',
    };
    var formatter = new Intl.DateTimeFormat(locale, options);
    return formatter.format(date);
};
/**
 * Month, day and year short date according to locale
 * @example
 * monthDayYearShort('en', date) === 'Apr 8th, 2019'
 */
exports.monthDayYearShort = function (locale, date) {
    var options = {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
    };
    var formatter = new Intl.DateTimeFormat(locale, options);
    return addOrdinals(locale, date, formatter, options);
};
/**
 * Weekday, month, and day date according to locale
 * @example
 * weekDayMonthDay('en', date) === 'Saturday, April 20th'
 */
exports.weekDayMonthDay = function (locale, date) {
    var options = {
        weekday: 'long',
        month: 'long',
        day: 'numeric',
    };
    var formatter = new Intl.DateTimeFormat(locale, options);
    return addOrdinals(locale, date, formatter, options);
};
/**
 * Weekday, month, day and year date according to locale
 * @example
 * weekDayMonthDayYear('en', date) === 'Saturday, April 20th, 2019'
 */
exports.weekDayMonthDayYear = function (locale, date) {
    var options = {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    };
    var formatter = new Intl.DateTimeFormat(locale, options);
    return addOrdinals(locale, date, formatter, options);
};
/**
 * Weekday, month, day and year short date according to locale
 * @example
 * weekDayMonthDayYearShort('en', date) === 'Sat, Apr 20th, 2019'
 */
exports.weekDayMonthDayYearShort = function (locale, date) {
    var options = {
        weekday: 'short',
        year: 'numeric',
        month: 'short',
        day: 'numeric',
    };
    var formatter = new Intl.DateTimeFormat(locale, options);
    return addOrdinals(locale, date, formatter, options);
};
/**
 * Hour and minute according to locale
 * @example
 * hourMinute('en', date) === '4:20 AM'
 */
exports.hourMinute = function (locale, date, tz) {
    var options = {
        hour: 'numeric',
        minute: 'numeric',
    };
    if (tz) {
        options.timeZone = tz;
        options.timeZoneName = 'short';
    }
    var formatter = new Intl.DateTimeFormat(locale, options);
    return formatter.format(date);
};
/**
 * Hour according to locale
 * @example
 * hour('en', date) === '4 AM'
 */
exports.hour = function (locale, date) {
    var options = {
        hour: 'numeric',
    };
    var formatter = new Intl.DateTimeFormat(locale, options);
    return formatter.format(date);
};
/**
 * The full short date according to locale
 * @example
 * fullDateShort('en', date) === 'Sat, Apr 20th, 2019, 4:20 AM'
 */
exports.fullDateShort = function (locale, date, tz) {
    var options = {
        weekday: 'short',
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
    };
    if (tz) {
        options.timeZone = tz;
        options.timeZoneName = 'short';
    }
    var formatter = new Intl.DateTimeFormat(locale, options);
    return addOrdinals(locale, date, formatter, options);
};
/**
 * The full short date range according to locale
 * @example
 * fullDateRangeShort('en', startDate, endDate) === 'Sat, Apr 20th, 2019, 4:20 - 4:40 AM'
 */
exports.fullDateRangeShort = function (locale, startDate, endDate, tz) {
    var startDateOptions = {
        year: 'numeric',
        month: 'short',
        weekday: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
    };
    var startFormatter = new Intl.DateTimeFormat(locale, startDateOptions);
    var startString;
    var endDateOptions;
    // If both times are on the same day, we only show the endDate time
    if (startDate.getFullYear() === endDate.getFullYear() &&
        startDate.getMonth() === endDate.getMonth() &&
        startDate.getDate() === endDate.getDate()) {
        endDateOptions = {
            hour: 'numeric',
            minute: 'numeric',
        };
        // If both times are in the same dayPeriod, we remove the startDate AM/PM
        if ((getDateDayPeriod(startDate) === getDateDayPeriod(endDate)) &&
            Intl.DateTimeFormat.prototype.formatToParts) {
            var parts = startFormatter.formatToParts(startDate);
            var ordinalParts = ordinal_1.formatOrdinalParts(locale, parts, startDateOptions);
            startString = ordinalParts
                .reduce(function (s, p) {
                return s + (p.type === 'dayPeriod' ? '' : p.value);
            }, '')
                .trim();
        }
        else {
            startString = addOrdinals(locale, startDate, startFormatter, startDateOptions);
        }
    }
    else {
        endDateOptions = {
            year: 'numeric',
            month: 'short',
            weekday: 'short',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
        };
        startString = addOrdinals(locale, startDate, startFormatter, startDateOptions);
    }
    if (tz) {
        endDateOptions.timeZone = tz;
        endDateOptions.timeZoneName = 'short';
    }
    var endFormatter = new Intl.DateTimeFormat(locale, endDateOptions);
    var endString = addOrdinals(locale, endDate, endFormatter, endDateOptions);
    return startString + " - " + endString;
};
/**
 * All month names according to locale
 * @example
 * monthNames('en') === ['January', 'February', 'March', ...]
 */
exports.monthNames = function (locale) {
    var options = {
        month: 'long',
    };
    var formatter = new Intl.DateTimeFormat(locale, options);
    var monthDates = Array.from(Array(12).keys()).map(function (i) {
        return new Date(i + 1 + "/20/2019");
    });
    return monthDates.map(function (month) { return formatter.format(month); });
};
/**
 * All weekday names according to locale
 * @example
 * weekdayNames('en') === ['Monday', 'Tuesday', 'Wednesday', ...]
 */
exports.weekdayNames = function (locale) {
    var options = {
        weekday: 'long',
    };
    var formatter = new Intl.DateTimeFormat(locale, options);
    var weekdayDates = Array.from(Array(7).keys()).map(function (i) {
        return new Date("4/" + (14 + i) + "/2019");
    });
    return weekdayDates.map(function (weekday) { return formatter.format(weekday); });
};
/**
 * All weekday short names according to locale
 * @example
 * weekdayShortNames('en') === ['Mon', 'Tues', 'Wed', ...]
 */
exports.weekdayShortNames = function (locale) {
    var options = {
        weekday: 'short',
    };
    var formatter = new Intl.DateTimeFormat(locale, options);
    var weekdayDates = Array.from(Array(7).keys()).map(function (i) {
        return new Date("4/" + (14 + i) + "/2019");
    });
    return weekdayDates.map(function (weekday) { return formatter.format(weekday); });
};
/**
 * Weekday name for provided date according to locale
 * @example
 * weekdayName('en', date) === 'Monday'
 */
exports.weekdayName = function (locale, date) {
    var options = {
        weekday: 'long'
    };
    var formatter = new Intl.DateTimeFormat(locale, options);
    return formatter.format(date);
};
/**
 * Weekday short name for provided date according to locale
 * @example
 * weekdayShortName('en', date) === 'Monday'
 */
exports.weekdayShortName = function (locale, date) {
    var options = {
        weekday: 'short'
    };
    var formatter = new Intl.DateTimeFormat(locale, options);
    return formatter.format(date);
};
/**
 * Index of weekdayNames() that is the start of week according to locale
 * @example
 * weekStartIndex('en') === 0
 * // Usage:
 * weekdayNames('en')[weekStartIndex('en')] === 'Sunday'
 */
exports.weekStartIndex = function (locale) {
    // Data from: https://github.com/moment/moment/tree/develop/locale
    var supportedFirstWeekdayLocales = function (loc) {
        switch (loc) {
            case 'mr':
            case 'ar-sa':
            case 'kn':
            case 'ne':
            case 'es-us':
            case 'en-us':
            case 'pa-in':
            case 'ta':
            case 'te':
            case 'ar-kw':
            case 'hi':
            case 'ar-dz':
            case 'bo':
            case 'bn':
                return 0;
            case 'vi':
            case 'en-nz':
            case 'pt':
            case 'kk':
            case 'lv':
            case 'gl':
            case 'pl':
            case 'bm':
            case 'el':
            case 'et':
            case 'gom-latn':
            case 'is':
            case 'sl':
            case 'nn':
            case 'hr':
            case 'ms':
            case 'fi':
            case 'tzl':
            case 'jv':
            case 'ru':
            case 'eu':
            case 'yo':
            case 'mk':
            case 'tlh':
            case 'sq':
            case 'ky':
            case 'uz-latn':
            case 'tg':
            case 'ka':
            case 'bg':
            case 'es-do':
            case 'sr-cyrl':
            case 'uz':
            case 'tl-ph':
            case 'af':
            case 'es':
            case 'ur':
            case 'ro':
            case 'eo':
            case 'br':
            case 'sw':
            case 'mi':
            case 'tr':
            case 'en-SG':
            case 'en-au':
            case 'ca':
            case 'sd':
            case 'cy':
            case 'nb':
            case 'be':
            case 'gd':
            case 'zh':
            case 'zh-cn':
            case 'de-at':
            case 'de-ch':
            case 'da':
            case 'fr-ch':
            case 'id':
            case 'az':
            case 'me':
            case 'se':
            case 'de':
            case 'fy':
            case 'ms-my':
            case 'bs':
            case 'sv':
            case 'uk':
            case 'cs':
            case 'fr':
            case 'nl':
            case 'en-gb':
            case 'sr':
            case 'mt':
            case 'hu':
            case 'nl-be':
            case 'en-ie':
            case 'lt':
            case 'ss':
            case 'hy-am':
            case 'it-ch':
            case 'cv':
            case 'sk':
            case 'it':
            case 'tet':
            case 'fo':
                return 1;
            case 'tzm':
            case 'tzm-latn':
            case 'fa':
            case 'ku':
            case 'ar-ma':
            case 'ar':
            case 'ar-ly':
                return 6;
            case 'dv':
                return 7;
        }
    };
    var lowerCaseLocale = locale.toLowerCase();
    var localesToTry = [lowerCaseLocale];
    if (locale.includes('-')) {
        localesToTry.push(lowerCaseLocale.split('-')[0]);
    }
    for (var _i = 0, localesToTry_1 = localesToTry; _i < localesToTry_1.length; _i++) {
        var loc = localesToTry_1[_i];
        var firstWeekdayNum = supportedFirstWeekdayLocales(loc);
        if (firstWeekdayNum) {
            return firstWeekdayNum;
        }
    }
    return 0;
};
//# sourceMappingURL=dateTimeFormatters.js.map